type ResidentialProps = {
  item: string;
  essential: boolean;
  plus: boolean;
  super: boolean;
};

export const residentials: ResidentialProps[] = [
  {
    item: 'Chaveiro',
    essential: true,
    plus: true,
    super: true
  },
  {
    item: 'Encanador',
    essential: true,
    plus: true,
    super: true
  },
  {
    item: 'Eletricista',
    essential: true,
    plus: true,
    super: true
  },
  {
    item: 'Vidraceiro',
    essential: false,
    plus: true,
    super: true
  },
  {
    item: 'Mudança e guarda móveis',
    essential: false,
    plus: true,
    super: true
  },
  {
    item: 'Desentupimento',
    essential: false,
    plus: true,
    super: true
  },
  {
    item: 'Limpeza de residência',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Cobertura provisória de telhados',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Revisão de instalados elétrica',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Troca de lâmpadas e tomadas',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Verificação de vazamentos',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Mudança de móveis',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Serviços gerais de fixação',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Substituição de telhas',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Troca ou instalação de chuveiros',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Instalação de ventilador de teto',
    essential: false,
    plus: false,
    super: true
  },
  {
    item: 'Instalação de lustres ou luminárias',
    essential: false,
    plus: false,
    super: true
  }
];

type BusinessProps = {
  item: string;
  withoutAssistence24: boolean;
  withAssistence24: boolean;
};

export const businesses: BusinessProps[] = [
  {
    item: 'Chaveiro comum',
    withoutAssistence24: false,
    withAssistence24: true
  },
  {
    item: 'Escritório virtual',
    withoutAssistence24: false,
    withAssistence24: true
  },
  {
    item: 'Mão de obra elétrica',
    withoutAssistence24: false,
    withAssistence24: true
  },
  {
    item: 'Mão de obra hidráulica',
    withoutAssistence24: false,
    withAssistence24: true
  },
  {
    item: 'Vidraceiro',
    withoutAssistence24: false,
    withAssistence24: true
  }
];
